<template>
  <div v-show="isLoaded" class="mBannerHoney-container" v-observe-visibility="startAnimate">
    <img class="mBannerHoney-image" :src="banner" alt="BannerHoney">
    <img class="mBannerHoney-image-desktop" :src="banner_desktop" alt="BannerHoney">
    <div class="mBannerHoney-title-container">
      <h1 class="mBannerHoney-title" :class="{animate: animate}">
        StrongBow
      </h1>
      <h2 class="mBannerHoney-subtitle" :class="{animate: animate}">
        Honey
      </h2>
    </div>
  </div>
</template>

<script>
import banner from '@/assets/honey/honey.png';
import banner_desktop from '@/assets/honey/banner_desktop.jpg';
import { mapGetters } from "vuex";
import Bowser from "bowser"; 

export default {
  name: "BannerHoney",
  data() {
    return {
      banner,
      banner_desktop,
      animate: false,
      isSafari: false
    };
  },
  computed: {
    ...mapGetters(["isLoaded"]),
  },
  methods: {
    startAnimate(isVisible) {
      if(isVisible) {
        this.animate=true
      } 
    }
  },
  components: {},
  beforeMount() {
    const browser = Bowser.getParser(window.navigator.userAgent);
    if (browser.getBrowserName()=='Safari') {
      this.isSafari = true
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/Honey/BannerHoney.scss";
</style>
